export class HandlerBase {
    /** @ignore */
    constructor(component, container, navigator) {
        this._component = component;
        this._container = container;
        this._navigator = navigator;
        this._enabled = false;
    }
    /**
     * Returns a Boolean indicating whether the interaction is enabled.
     *
     * @returns {boolean} `true` if the interaction is enabled.
     */
    get isEnabled() {
        return this._enabled;
    }
    /**
     * Enables the interaction.
     *
     * @example ```<component-name>.<handler-name>.enable();```
     */
    enable() {
        if (this._enabled || !this._component.activated) {
            return;
        }
        this._enable();
        this._enabled = true;
        this._component.configure(this._getConfiguration(true));
    }
    /**
     * Disables the interaction.
     *
     * @example ```<component-name>.<handler-name>.disable();```
     */
    disable() {
        if (!this._enabled) {
            return;
        }
        this._disable();
        this._enabled = false;
        if (this._component.activated) {
            this._component.configure(this._getConfiguration(false));
        }
    }
}
//# sourceMappingURL=HandlerBase.js.map